/**
 * Formats a client ID with thousand separators using dots
 * @param clientId - The numeric client ID to format
 * @returns The formatted client ID string with dots as thousand separators
 * @example
 * formatClientId(1234567) // "1.234.567"
 * formatClientId(123) // "123"
 */
const formatClientId = (clientId: number | string): string => {
  if (!clientId) return '';

  const numericId = typeof clientId === 'string' ? parseInt(clientId, 10) : clientId;

  if (Number.isNaN(numericId)) return String(clientId);

  return numericId.toLocaleString('de-DE'); // German locale uses dots as thousand separators
};

export default formatClientId;
